import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ProductContent = (props) => {
    const { firstRow, secondRow, indent, needValidate, needAction, hasError } =
        props;
    const className = indent == null ? 'px-4' : 'px-8';

    const getClassName = (needValidate, needAction) => {
        if (needValidate) {
            return 'flex flex-row font-bold text-yellow-100';
        }
        if (needAction) {
            return 'flex flex-row font-bold text-red-100';
        }
        return 'flex flex-row font-bold';
    };

    return (
        <div className={className}>
            {needValidate || needAction ? (
                <div className={getClassName(needValidate, needAction)}>
                    <div>{firstRow}</div>
                    <div className="ml-2">{'*'}</div>
                </div>
            ) : hasError ? (
                <div className="flex flex-row font-bold text-red-100">
                    <div>{firstRow}</div>
                    <FontAwesomeIcon icon="fa-solid fa-circle-info" />
                </div>
            ) : (
                <div className="font-bold">{firstRow}</div>
            )}
            <div className="text-sm text-black-30">{secondRow}</div>
        </div>
    );
};
